import Vue from 'vue';
import Vuex from 'vuex';

import codeDictionary from './store_codeDictionary';
import common from './store_common';
import auth from './store_auth';

import nice from './store_nice';

import booking from './store_booking';
import brand from './store_brand';
import dealer from './store_dealer';
import shop from './store_shop';
import trim from './store_trim';
import sc from './store_sc';
import banner from './store_banner';

import board from './store_board';
import faq from './store_faq';
import qna from './store_qna';

import resource from './store_resource';
import review from './store_review';

import { orderby, sort } from '../utils/table';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {

        codeDictionary,
        common,
        auth,
        nice,

        booking,
        brand,
        dealer,
        shop,
        trim,
        sc,
        banner,
    
        board,
        faq,
        qna,

        resource,
        review
    },
    state: {
        host: window.location.origin,
        dir: process.env.BASE_URL,

        routeBack: -1,
        header:true,
        headerBlank:true,
        headerBookmark:false,
        headerTitle:'',
        footer:false,

        orderby,
        sort,

        // 임시 위치 데이터
        currentLocationLat: 37.54707,
        currentLocationHar: 127.05162,
        currentLocationOnload: false,

        kakaoClientId: '26eab7842c02794b351f52696fefff5d',
        kakaoScope: 'account_email, profile_nickname, profile_image, birthday',

        googleClientId: '886313997213-pi1rd2adaheuimutivpnoqve26t3jk7d.apps.googleusercontent.com',
        googleScope: 'profile email', 

    },
    mutations: {

        SET_CURRENT_LOCATION(state, { lat, har }){

            if(lat != 0 && lat != '0' && lat != '' && lat != null)
                state.currentLocationLat = lat;
            if(har != 0 && har != '0' && har != '' && har != null)
                state.currentLocationHar = har;
                
            state.currentLocationOnload = true;
        },

        RESET_ROUTE_BACK(state) {
            state.routeBack = -1;
        },

        RESET_HEADER(state){
            state.header = true;
            state.headerBlank = true;
            state.headerBookmark = false,
            state.headerTitle = '';
        },

        RESET_FOOTER(state){
            state.footer = false;
        },
        
    },
    actions: {
    },

})
